import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { DeliveryAccEntrepreneur } from '../all-entrepreneurs-view.part';


export function getColumns(util: UtilityService) {

	const isVentureDroppedOut = (row: DeliveryAccEntrepreneur) => row.ventureStatus === 'Dropped Out' || row.ventureStatus === 'Never Started';

	const columns: GridColumn<DeliveryAccEntrepreneur, unknown>[] = [
		buildColumn(util, 'Id', row => row.accEntrepreneurId, { header: 'accEntrepreneurId' }),
		buildColumn(util, 'Id', row => row.accId, { header: 'accId' }),
		buildColumn(util, 'Text', row => row.accName, { header: 'AccName' }),
		buildColumn(util, 'Id', row => row.personId, { header: 'personId' }),
		buildColumn(util, 'FullName', row => row.name, { header: 'Name' }),
		buildColumn(util, 'Id', row => row.accVentureId, { header: 'accVentureId' }),
		buildColumn(util, 'Text', row => row.ventureName, { header: 'Venture Name', renderCellClasses: row => isVentureDroppedOut(row) ? ['grid-cell-strikethrough', 'grid-cell-red-text'] : [] }),
		buildColumn(util, 'Text', row => row.ventureStatus, { header: 'Status' }),
		buildColumn(util, 'Text', row => row.location, { header: 'Location' }),
		buildColumn(util, 'Number', row => row.presentCount, { header: 'Present' }),
		buildColumn(util, 'Number', row => row.absentCount, { header: 'Absent' }),
		buildColumn(util, 'Number', row => row.surveysCount, { header: 'Surveys Completed' }),
		buildColumn(util, 'Percent', row => row.courseCompletionPercentage, { header: 'Course Completion %' }),
	];


	return columns;

}